import React, { useEffect, useState } from "react";
import { Button, Table, Card, Space, Tag, Spin, message } from "antd";
import { PlusOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getJobsApi } from "../../../apiservice/ats";

const JobsList = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load jobs from API
  const loadJobs = async () => {
    try {
      setLoading(true);
      const res = await getJobsApi();
      setJobs(res.data || []);
    } catch (err) {
      console.error(err);
      message.error("Failed to load jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadJobs();
  }, []);

  const handleAddNew = () => {
    navigate("/ats/jobs/new");
  };

  const handleEdit = (id) => {
    navigate(`/ats/jobs/${id}/edit`);
  };

  const handleView = (id) => {
    navigate(`/ats/jobs/${id}/view`);
  };

  const columns = [
    { title: "Job Title", dataIndex: "title", key: "title" },
    { title: "Client", dataIndex: "client", key: "client" },
    { title: "Location", dataIndex: "location", key: "location" },
    { 
      title: "Status", 
      dataIndex: "status", 
      key: "status",
      render: (status) =>
        status === "active" ? <Tag color="green">Active</Tag> : <Tag color="red">Closed</Tag>
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button icon={<EyeOutlined />} onClick={() => handleView(record.id)}>View</Button>
          <Button icon={<EditOutlined />} onClick={() => handleEdit(record.id)}>Edit</Button>
        </Space>
      ),
    },
  ];

  return (
    <Card
      title="Jobs"
      extra={
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNew}>
          Add New
        </Button>
      }
      styles={{ header: { flexWrap: "wrap", height: "auto", rowGap: 8 } }}
    >
      {loading ? (
        <Spin size="large" style={{ display: "block", margin: 40 }} />
      ) : (
        <Table
          columns={columns}
          dataSource={jobs}
          rowKey="id"
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 10 }}
        />
      )}
    </Card>
  );
};

export default JobsList;
